<template>
    <div class="wrapper">
        <ul class="list">
            <li v-if="list_status == 0" class="no-record">
                <p class="no-record-text">
                    No Records
                </p>
                <router-link to="" @click="goback" class="no-record-goback">Go Back</router-link>
            </li>
            <li v-else class="element" v-for="(element,ind) in obj.list" :key="ind" @click.prevent="toggle(ind)">
                <div class="question">
                    <span v-text="`Time: ${element.createTime}`"></span>
                    <p class="question-content" v-text="`Content: ${element.content}`"></p>
                    <div class="img-containers">
                        <div class="img-container" v-for="(ele,ind) in element.imges" :key="ind">
                            <img :src="ele" alt="">
                        </div>
                    </div>
                    <div class="feedback" v-show="element.answerContent">
                        <span class="feedback-time" v-text="`Time: ${element.responseTime}`"></span>
                        <p class="feedback-content" v-text="`Content: ${element.answerContent}`"></p>
                    </div>                
                </div>                
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import "assets/less/icon.less";
    .no-record{
        padding:50px;
        .no-record-text{
            font-size:40px;
            text-align:center;
            margin-bottom: 50px;
        }
        .no-record-goback {
            display: block;
            width:300px;
            height:80px;
            line-height: 80px;
            text-align: center;
            background:#9C73E2;
            color:#fff;
            border-radius: 20px;
            font-size: 32px;
            margin:0 auto;
        }
    }
    .wrapper{
        padding:30px;
        .list{
            .element{
                padding:30px 30px 0 30px;
                background:#e7defa;
                border-radius: 20px;
                margin-bottom: 30px;
                .question{                    
                    padding-bottom: 30px;
                    border-bottom:2px solid #e7e7e7;
                    .img-containers{
                        padding:20px 0;
                        .img-container{
                            width: 100px;
                            height: 100px;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                    span{
                        font-size: 30px;
                        font-weight: 700;
                        line-height: 1.5;
                        color:#9C73E2;
                        flex: 1 1 auto
                    }
                    .question-content{
                        margin-top: 15px;
                        color:#9C73E2;
                        font-size: 30px;
                        margin-bottom: 30px;
                    }
                    .icon{
                        flex: 0 0 auto;
                    }
                    .feedback{
                        padding:10px 30px;
                        background:#fff;
                        border-radius: 20px;
                        .feedback-time{
                            color:#d1c7e7;
                            font-size: 30px;
                        }
                        .feedback-content{
                            color:#333;
                            font-size: 32px;
                            line-height:1.5
                        }
                    }
                }                
            }
        }
    }
</style>
<script>
import { onMounted,reactive,ref } from 'vue';
import { feedbackList } from '@api/index.js';
import { useRouter } from 'vue-router';
export default {
    setup () {
        const router = useRouter()
        const obj = reactive({
            list:[]
        })
        const goback = () => {
            router.go(-1)
        }
        const list_status = ref(0)
        const toggle = (ind) => {
            obj.list[ind].show = !obj.list[ind].show
        }
        onMounted(()=>{
            feedbackList().then(res => {
                if(res.code == 0) {
                    if(res.data.length > 0) {
                        list_status.value = 1
                    } 
                    obj.list = res.data.map((element,ind) => {
                        if(ind == 0) {
                            element.show = true
                        } else {
                            element.show = false
                        }
                        return element
                    })
                }
            })
        })
        return {
            obj,
            toggle,
            goback,
            list_status
        }
    }
}
</script>